import React from "react";
import PropTypes from "prop-types";
import appStoreLogoUrl from "app-store-logo.svg";
import styles from "components/dashboard/dashboard.scss";
import { Button } from "components/common/button";

export const NoUsageDashboard = ({ name }) => (
  <div>
    <h1>Hey there { name }!</h1>
    <div className={ styles["usage-container"] }>
      <h1>It looks like you haven&apos;t uploaded anything yet!</h1>
      <div className={ styles.upload }>
        <Button primary>Click here to upload a document</Button>
      </div>
      <h2>Or download our iPhone app:</h2>
      <a
        href="https://itunes.apple.com/au/app/shoeboxed-australia-document/id1044924996?mt=8"
        rel="noopener noreferrer"
        target="_blank"
      >
        <img alt="app store logo" src={ appStoreLogoUrl } />
      </a>
    </div>
  </div>
);

NoUsageDashboard.propTypes = {
  name: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/dashboard/no-usage-dashboard.jsx